// extracted by mini-css-extract-plugin
module.exports = {"active":"styles_active__1WcIK"};